import React from "react";
import { Switch, Route } from "react-router-dom";
import ConviteViews from "views/convite-views";

export const ConviteLayout = () => {
	return (
		<div className="auth-container">
			<Switch>
				<Route path="" component={ConviteViews} />
			</Switch>
		</div>
	);
};

export default ConviteLayout;
